import Vue from 'vue'
import Router from 'vue-router'
import {
  setTitle
} from './setTitle'

const index = resolve => require.ensure([], () => resolve(require('@/components/index')), 'index')
const chat = resolve => require.ensure([], () => resolve(require('@/components/chat')), 'chat')
const success = resolve => require.ensure([], () => resolve(require('@/components/tools/success')), 'success')
const successOrder = resolve => require.ensure([], () => resolve(require('@/components/tools/successOrder')), 'successOrder')

const birth = resolve => require.ensure([], () => resolve(require('@/components/chat/birthDay')), 'birth')
const gift = resolve => require.ensure([], () => resolve(require('@/components/chat/gift')), 'gift')

//拓客
const toker = resolve => require.ensure([], () => resolve(require('@/components/chat/toker')), 'toker')
const tokerGift = resolve => require.ensure([], () => resolve(require('@/components/chat/tokerGift')), 'tokerGift')
// 预约提醒
const futureCustomers = resolve => require.ensure([], () => resolve(require('@/components/chat/futureCustomers')), 'futureCustomers')
const futureCustomersDetail = resolve => require.ensure([], () => resolve(require('@/components/chat/futureCustomersDetail')), 'futureCustomersDetail')

const menu = resolve => require.ensure([], () => resolve(require('@/components/chat/menu')), 'menu')
// const reminding = resolve => require.ensure([], () => resolve(require('@/components/chat/reminding')), 'reminding')
const readySend = resolve => require.ensure([], () => resolve(require('@/components/chat/readySend')), 'readySend')
const reRecord = resolve => require.ensure([], () => resolve(require('@/components/chat/record')), 'reRecord')
const remindContent = resolve => require.ensure([], () => resolve(require('@/components/chat/remindContent')), 'remindContent')
const singleChat = resolve => require.ensure([], () => resolve(require('@/components/chat/singleChat')), 'singleChat')
const _marketingProgram = resolve => require.ensure([], () => resolve(require('@/components/chat/marketingProgram')), 'marketingProgram')



const cash = resolve => require.ensure([], () => resolve(require('@/components/cash/cash')), 'cash')
const bonus = resolve => require.ensure([], () => resolve(require('@/components/cash/bonus')), 'bonus')
const outList = resolve => require.ensure([], () => resolve(require('@/components/cash/outList')), 'outList')
const inList = resolve => require.ensure([], () => resolve(require('@/components/cash/inList')), 'inList')
const waterList = resolve => require.ensure([], () => resolve(require('@/components/cash/waterList')), 'waterList')

const present = resolve => require.ensure([], () => resolve(require('@/components/friend/present')), 'present')
const preRecord = resolve => require.ensure([], () => resolve(require('@/components/friend/preRecord')), 'preRecord')
const sendDetail = resolve => require.ensure([], () => resolve(require('@/components/friend/sendDetail')), 'sendDetail')
const appointment = resolve => require.ensure([], () => resolve(require('@/components/friend/appointment')), 'appointment')
const appointList = resolve => require.ensure([], () => resolve(require('@/components/friend/appointList')), 'appointList')
const itemShare = resolve => require.ensure([], () => resolve(require('@/components/friend/share')), 'itemShare')
const receivePresent = resolve => require.ensure([], () => resolve(require('@/components/friend/receive')), 'receivePresent')
const balance = resolve => require.ensure([], () => resolve(require('@/components/balance')), 'balance')
const timer = resolve => require.ensure([], () => resolve(require('@/components/tools/timer')), 'timer')
const staff = resolve => require.ensure([], () => resolve(require('@/components/tools/staff')), 'staff')
const stores = resolve => require.ensure([], () => resolve(require('@/components/tools/stores')), 'stores')
const staffStores = resolve => require.ensure([], () => resolve(require('@/components/tools/staffStores')), 'staffStores')
const item = resolve => require.ensure([], () => resolve(require('@/components/tools/item')), 'item')
const activeEnd = resolve => require.ensure([], () => resolve(require('@/components/tools/activeEnd')), 'activeEnd')
const shoppingSheet = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/shoppingSheet')), 'shoppingSheet')
const decrement = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/decrement')), 'decrement')

const sales = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/sales')), 'sales')
const charge = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/charge')), 'charge')
const earnest = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/earnest')), 'earnest')
const change = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/change')), 'change')
const returns = resolve => require.ensure([], () => resolve(require('@/components/shoppingSheet/returns')), 'returns')
const store = resolve => require.ensure([], () => resolve(require('@/components/store/store')), 'store')
const storeDetail = resolve => require.ensure([], () => resolve(require('@/components/store/storeDetail')), 'storeDetail')

// 订单
const bill = resolve => require.ensure([], () => resolve(require('@/components/store/bill.vue')), 'bill')
const address = resolve => require.ensure([], () => resolve(require('@/components/store/address')), 'address')
const addAddress = resolve => require.ensure([], () => resolve(require('@/components/store/addAddress')), 'addAddress')

const payFinish = resolve => require.ensure([], () => resolve(require('@/components/store/payFinish')), 'payFinish')
const storeManager = resolve => require.ensure([], () => resolve(require('@/components/storeManage/storeManager')), 'storeManager')

//预约
const appointMe = resolve => require.ensure([], () => resolve(require('@/pages/appointment/appoint-me/AppointMe.vue')), 'appointMe')
const appointAll = resolve => require.ensure([], () => resolve(require('@/components/storeManage/appointAll')), 'appointAll')
const quickAppoint = resolve => require.ensure([], () => resolve(require('@/components/storeManage/quickAppoint')), 'quickAppoint')

const myShift = resolve => require.ensure([], () => resolve(require('@/components/storeManage/myShift')), 'myShift')
const setTimeOut = resolve => require.ensure([], () => resolve(require('@/components/storeManage/setTimeOut')), 'setTimeOut')
const appointSource = resolve => require.ensure([], () => resolve(require('@/components/storeManage/appointSource')), 'appointSource')
const treeStore = resolve => require.ensure([], () => resolve(require('@/components/storeManage/treeStore')), 'treeStore')
const source = resolve => require.ensure([], () => resolve(require('@/components/storeManage/source')), 'source')
const accountList = resolve => require.ensure([], () => resolve(require('@/components/storeManage/accountList')), 'accountList')

//团购
const groupIndex = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/index')), 'groupIndex')
const groupDetails = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/groupDetails/groupDetails')), 'groupDetails')
const groupShare = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/groupShare')), 'groupShare')
// const groupBuy = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/buy')), 'groupBuy')
const groupStatus = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/groupStatus')), 'groupStatus')
const groupDetail = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/groupDetail')), 'groupDetail')


//秒杀
const seckillIndex = resolve => require.ensure([], () => resolve(require('@/components/seckill/index')), 'seckillIndex')
const seckillDetail = resolve => require.ensure([], () => resolve(require('@/components/seckill/detail')), 'seckillDetail')
const seckillRecord = resolve => require.ensure([], () => resolve(require('@/components/seckill/record')), 'seckillRecord')
const seckillEvaluate = resolve => require.ensure([], () => resolve(require('@/components/seckill/evaluate')), 'seckillEvaluate')
const editEvalute = resolve => require.ensure([], () => resolve(require('@/components/seckill/editEvalute')), 'editEvalute')

//疯狂拓客
const tuokeIndex = resolve => require.ensure([], () => resolve(require('@/components/tuoke/index.vue')), 'tuokeIndex')
const tuokeDetail = resolve => require.ensure([], () => resolve(require('@/components/tuoke/detail.vue')), 'tuokeDetail')
const tuokeRecord = resolve => require.ensure([], () => resolve(require('@/components/tuoke/record.vue')), 'tuokeRecord')
const tuokeEvalute = resolve => require.ensure([], () => resolve(require('@/components/tuoke/evalute.vue')), 'tuokeEvalute')
const tuokeEvaluteEdit = resolve => require.ensure([], () => resolve(require('@/components/tuoke/editEvalute.vue')), 'tuokeEvaluteEdit')

const selectType = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/selectType')), 'selectType')
const memberType = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/memberType')), 'memberType')

//分享
const share = resolve => require.ensure([], () => resolve(require('@/components/share/index')), 'share')

const paySuccess = resolve => require.ensure([], () => resolve(require('@/components/groupBuy/paySuccess')), 'paySuccess')


//邀请员工
const invite = resolve => require.ensure([], () => resolve(require('@/components/invite/invite')), 'invite')
const invitor = resolve => require.ensure([], () => resolve(require('@/components/invite/invitor')), 'invitor')

//扫码登录
const swipeCode = resolve => require.ensure([], () => resolve(require('@/components/swipeCode/index')), 'swipeCode')
const swipeStore = resolve => require.ensure([], () => resolve(require('@/components/swipeCode/swipeStore')), 'swipeStore')
const swipeSuccess = resolve => require.ensure([], () => resolve(require('@/components/swipeCode/swipeSuccess')), 'swipeSuccess')

//九宫格 抽奖
const plaidLottery = resolve => require.ensure([], () => resolve(require('@/components/plaidLottery/plaidLottery')), 'plaidLottery')
// const WinningSubmissionSuccess = resolve => require.ensure([], () => resolve(require('@/components/common/WinningSubmissionSuccess/WinningSubmissionSuccess')), 'WinningSubmissionSuccess')


//评论

const comment = resolve => require.ensure([], () => resolve(require('@/components/common/comment/comment')), 'comment')
const tweet = resolve => require.ensure([], () => resolve(require('@/components/tweet/tweet')), 'tweet')

const commentList = resolve => require.ensure([], () => resolve(require('@/components/common/comment/commentList')), 'commentList')

//领取礼物
const getGift = resolve => require.ensure([], () => resolve(require('@/components/gift/detail.vue')), 'getGift')
const receiveSuccess = resolve => require.ensure([], () => resolve(require('@/components/gift/receiveSuccess.vue')), 'receiveSuccess')
const giftEvalute = resolve => require.ensure([], () => resolve(require('@/components/gift/evalute.vue')), 'giftEvalute')
const editGiftEvalute = resolve => require.ensure([], () => resolve(require('@/components/gift/editEvalute.vue')), 'editGiftEvalute')
const giftRecord = resolve => require.ensure([], () => resolve(require('@/components/gift/record.vue')), 'giftRecord')


//营销活动报名
const activityRegistration = resolve => require.ensure([], () => resolve(require('@/pages/activityRegistration/index.vue')), 'activityRegistration')
//营销确认报名
const confirmRegistration = resolve => require.ensure([], () => resolve(require('@/pages/activityRegistration/confirmRegistration.vue')), 'confirmRegistration')
//营销确认报名成功
const registrationSuccess = resolve => require.ensure([], () => resolve(require('@/pages/activityRegistration/registrationSuccess.vue')), 'registrationSuccess')
//营销确认报名人数列表
const registrationRecord = resolve => require.ensure([], () => resolve(require('@/pages/activityRegistration/record.vue')), 'registrationRecord')




//商城
const mallIndex = resolve => require.ensure([], () => resolve(require('@/components/mall/index.vue')), 'mallIndex')
const mallDetail = resolve => require.ensure([], () => resolve(require('@/components/mall/detail.vue')), 'mallDetail')
const mallRecord = resolve => require.ensure([], () => resolve(require('@/components/mall/record.vue')), 'mallRecord')
const mallEvalute = resolve => require.ensure([], () => resolve(require('@/components/mall/evalute.vue')), 'mallEvalute')
const mallEvaluteEdit = resolve => require.ensure([], () => resolve(require('@/components/mall/editEvalute.vue')), 'mallEvaluteEdit')
//个人资料
const personal = resolve => require.ensure([], () => resolve(require('@/components/personal/personal.vue')), 'personal')
const subordinate = resolve => require.ensure([], () => resolve(require('@/components/personal/subordinate.vue')), 'subordinate')

//营销方案
const marketingprogram = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/marketingprogram.vue')), 'marketingprogram')
const marketingdetail = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/marketingdetail.vue')), 'marketingdetail')
const marketingMemberShare = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/memberShare.vue')), 'marketingMemberShare')
const marketingShop = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/shop.vue')), 'marketingShop')
const marketingmember = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/marketingmember.vue')), 'marketingmember')
const marketingShoppingDetail = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/marketingShoppingDetail.vue')), 'marketingShoppingDetail')
const memberdetail = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/memberdetail.vue')), 'memberdetail')
const marketingRedPacket = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/marketingRedPacket.vue')), 'marketingRedPacket')
const redPacketRecharge = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/redPacketRecharge.vue')), 'redPacketRecharge')
const rechargeSuccess = resolve => require.ensure([], () => resolve(require('@/components/marketingprogram/rechargeSuccess.vue')), 'rechargeSuccess')

//报表
const commission = resolve => require.ensure([], () => resolve(require('@/components/commission/commission.vue')), 'commission')
const percommission = resolve => require.ensure([], () => resolve(require('@/components/commission/percommission.vue')), 'percommission')
//营销分享
const MarketingShare = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/MarketingShare.vue')), 'MarketingShare')
const MarketingShares = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/MarketingShares.vue')), 'MarketingShares')


const AddThousandFaces = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/addThousandFaces.vue')), 'AddThousandFaces')
const AddChatThousandFaces = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/addChatThousandFaces.vue')), 'AddChatThousandFaces')
const PreviewItem = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/previewItem.vue')), 'PreviewItem')
const PreviewChatItem = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/previewChatItem.vue')), 'PreviewChatItem')
const MemberBuy = resolve => require.ensure([], () => resolve(require('@/components/MarketingShare/memberBuy.vue')), 'MemberBuy')
import appointments from './appoint-router';


const mintUiTest = resolve => require.ensure([], () => resolve(require('@/components/mint-ui-test/test.vue')), 'test')

// 营业报表
const operStatement = resolve => require.ensure([], () => resolve(require('@/pages/operStatement/index.vue')), 'operStatement')
const operStatementDetall = resolve => require.ensure([], () => resolve(require('@/pages/operStatement/detall.vue')), 'operStatementDetall')

// 服务评价
const serviceComment = resolve => require.ensure([], () => resolve(require('@/pages/serviceComment/index.vue')), 'serviceComment')
const serviceCommentDetail = resolve => require.ensure([], () => resolve(require('@/pages/serviceComment/detail.vue')), 'serviceCommentDetail')

//回访提醒
// Reminding to revisit
//关注提现
const attentionCash = resolve => require.ensure([], () => resolve(require('@/pages/attentionCash/index.vue')), 'attentionCash')
//对账
const organizationBill = resolve => require.ensure([], () => resolve(require('@/pages/organizationBill/organizationBill.vue')), 'organizationBill')


const pullToTest = resolve => require.ensure([], () => resolve(require('@/pages/test/pullToTest.vue')), 'pullToTest')

// 微信绑定公众号成功跳转页面
const successPage = resolve => require.ensure([], () => resolve(require('@/pages/forwxapp/successPage.vue')), 'successPage')

//    回访
const remindingRevisit = resolve => require.ensure([], () => resolve(require('@/components/remindingRevisit/remindingRevisit.vue')), 'remindingRevisit')

//顾客分类
const importMobile = resolve => require.ensure([], () => resolve(require('@/pages/importMobile/index.vue')), 'importMobile')

const addMobile = resolve => require.ensure([], () => resolve(require('@/pages/importMobile/addMobile.vue')), 'addMobile')
//投票
const vote = resolve => require.ensure([], () => resolve(require('@/pages/vote/vote.vue')), 'vote')
const rank = resolve => require.ensure([], () => resolve(require('@/pages/vote/rank.vue')), 'rank')
const description = resolve => require.ensure([], () => resolve(require('@/pages/vote/description.vue')), 'description')
const home = resolve => require.ensure([], () => resolve(require('@/pages/vote/home.vue')), 'home')
const voteIndex = resolve => require.ensure([], () => resolve(require('@/pages/vote/index.vue')), 'voteIndex');
const voteUpdateImage = resolve => require.ensure([], () => resolve(require('@/pages/vote/updateImage.vue')), 'voteUpdateImage');
const voteNumberPerson = resolve => require.ensure([], () => resolve(require('@/pages/vote/voteNumberPerson.vue')), 'voteNumberPerson');
const voteQRCode = resolve => require.ensure([], () => resolve(require('@/pages/vote/voteQRCode.vue')), 'voteQRCode');
const voteDetails = resolve => require.ensure([], () => resolve(require('@/pages/vote/voteDetails.vue')), 'voteDetails');
const lookOverHome = resolve => require.ensure([], () => resolve(require('@/pages/vote/lookOverHome.vue')), 'lookOverHome');
const voteDescription = resolve => require.ensure([], () => resolve(require('@/pages/vote/voteDescription.vue')), 'voteDescription');







//订单
const orderDetail = resolve => require.ensure([], () => resolve(require('@/pages/order/orderDetail.vue')), 'orderDetail');
const orderIndex = resolve => require.ensure([], () => resolve(require('@/pages/order/index.vue')), 'orderIndex');
const orderBilling = resolve => require.ensure([], () => resolve(require('@/pages/order/billing.vue')), 'orderBilling');

//编辑
const editOrdePrice = resolve => require.ensure([], () => resolve(require('@/pages/order/editPrice.vue')), 'editOrdePrice');
const editPayType = resolve => require.ensure([], () => resolve(require('@/pages/order/editPayType.vue')), 'editPayType');
const editOrderStaff = resolve => require.ensure([], () => resolve(require('@/pages/order/editStaff.vue')), 'editOrderStaff');
const editOrderItem = resolve => require.ensure([], () => resolve(require('@/pages/order/editItem.vue')), 'editOrderItem');
const repaymentItem = resolve => require.ensure([], () => resolve(require('@/pages/order/repayment.vue')), 'repaymentItem');


//今日到店
const inShop = resolve => require.ensure([], () => resolve(require('@/pages/inShop/inShop.vue')), 'inShop');
const modifyStoreMember = resolve => require.ensure([], () => resolve(require('@/pages/inShop/modifyStoreMember.vue')), 'modifyStoreMember');
const customerPhotos = resolve => require.ensure([], () => resolve(require('@/pages/inShop/customerPhotos.vue')), 'customerPhotos');
const addPhotos = resolve => require.ensure([], () => resolve(require('@/pages/inShop/addPhotos.vue')), 'addPhotos');
const comparePhotos = resolve => require.ensure([], () => resolve(require('@/pages/inShop/comparePhotos.vue')), 'comparePhotos');
const memberMediaCompare = resolve => require.ensure([], () => resolve(require('@/pages/inShop/memberMediaCompare.vue')), 'memberMediaCompare');

//投票完成
const votedone = resolve => require.ensure([], () => resolve(require('@/pages/votedone/votedone.vue')), 'votedone');
//拓客页面
const addGuest = resolve => require.ensure([], () => resolve(require('@/pages/addGuest/addGuest.vue')), 'addGuest');
//新增统计
const addStatistics = resolve => require.ensure([], () => resolve(require('@/pages/addStatistics/addStatistics.vue')), 'addStatistics');
//购买明细
const buyDetail = resolve => require.ensure([], () => resolve(require('@/pages/buyDetail/buyDetail.vue')), 'buyDetail');
//拓客选择套餐
const selectPackage = resolve => require.ensure([], () => resolve(require('@/components/tools/selectPackage')), 'selectPackage')
//选择话术
const selectSpeech = resolve => require.ensure([], () => resolve(require('@/components/tools/selectSpeech')), 'selectSpeech')
//创建门店
const createShop = resolve => require.ensure([], () => resolve(require('@/pages/createShop/createShop.vue')), 'createShop');
const editShop = resolve => require.ensure([], () => resolve(require('@/pages/createShop/editShop.vue')), 'editShop');
const inviteStaff = resolve => require.ensure([], () => resolve(require('@/pages/createShop/inviteStaff.vue')), 'inviteStaff');
const editStaff = resolve => require.ensure([], () => resolve(require('@/pages/createShop/editStaff.vue')), 'editStaff');

//服务评价
const serviceEvaluation = resolve => require.ensure([], () => resolve(require('@/pages/serviceEvaluation/index.vue')), 'editStaff');
const evaluationSuccess = resolve => require.ensure([], () => resolve(require('@/pages/serviceEvaluation/success.vue')), 'editStaff');

// 回访
const returnVisit = resolve => require.ensure([], () => resolve(require('@/pages/returnVisit/index.vue')), 'returnVisit');
const addReturnVisit = resolve => require.ensure([], () => resolve(require('@/pages/returnVisit/add.vue')), 'addReturnVisit');
const addOfTemplate = resolve => require.ensure([], () => resolve(require('@/pages/returnVisit/addOfTemplate.vue')), 'addOfTemplate');
const visitTemplate = resolve => require.ensure([], () => resolve(require('@/pages/returnVisit/visitTemplate.vue')), 'visitTemplate');
const AgentClient = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/AgentClient.vue')), 'AgentClient');
const AgentClientIndex = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/index.vue')), 'AgentClientIndex');
const ClientIndex = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/client.vue')), 'ClientIndex');
const ClientWxAuth = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/clientAuth.vue')), 'ClientWxAuth');
const TemplateList = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/templateList.vue')), 'TemplateList');
const ClientChooseOrder = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/chooseOrder.vue')), 'ClientChooseOrder');
const AgentDetail = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/detail.vue')), 'AgentDetail');
const AgentQrcode = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/qrcode.vue')), 'AgentQrcode');
const AgentEdit = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/edit.vue')), 'AgentEdit');
const AgentEditPrice = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/editPrice.vue')), 'AgentEditPrice');
const AgentAddStore = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/addStore.vue')), 'AgentAddStore');
const AgentPayCreateOrder = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/payCreateOrder.vue')), 'AgentPayCreateOrder');
const AgentPaySuccess = resolve => require.ensure([], () => resolve(require('@/pages/AgentClient/paySuccess.vue')), 'AgentPaySuccess');

//我

const agentIndex = resolve => require.ensure([], () => resolve(require('@/pages/agent/index.vue')), 'agentIndex')
const personalIndex = resolve => require.ensure([], () => resolve(require('@/pages/personal/index.vue')), 'personalIndex')
const personalAgent = resolve => require.ensure([], () => resolve(require('@/pages/personal/agent.vue')), 'personalAgent')
const approvalAgent = resolve => require.ensure([], () => resolve(require('@/pages/personal/approvalAgent.vue')), 'approvalAgent')
const approvalColleague = resolve => require.ensure([], () => resolve(require('@/pages/personal/approvalColleague.vue')), 'approvalColleague')
const colleague = resolve => require.ensure([], () => resolve(require('@/pages/personal/colleague.vue')), 'colleague')
const companyDetail = resolve => require.ensure([], () => resolve(require('@/pages/personal/companyDetail.vue')), 'companyDetail')
const pAgentDetail = resolve => require.ensure([], () => resolve(require('@/pages/personal/agentDetail.vue')), 'pAgentDetail')
const colleagueDetail = resolve => require.ensure([], () => resolve(require('@/pages/personal/colleagueDetail.vue')), 'colleagueDetail')
const approvalAgentDetail = resolve => require.ensure([], () => resolve(require('@/pages/personal/approvalAgentDetail.vue')), 'approvalAgentDetail')
const editAgent = resolve => require.ensure([], () => resolve(require('@/pages/personal/editAgent.vue')), 'editAgent')
const personalCharge = resolve => require.ensure([], () => resolve(require('@/pages/personal/charge.vue')), 'personalCharge')
const personalInvite = resolve => require.ensure([], () => resolve(require('@/pages/personal/invite.vue')), 'personalInvite')
const personalQrcode = resolve => require.ensure([], () => resolve(require('@/pages/personal/qrcode.vue')), 'personalQrcode')
const personalSuccess = resolve => require.ensure([], () => resolve(require('@/pages/personal/success.vue')), 'personalSuccess')

//代理商平台审核  2 /agent/noPermission
const noPermission = resolve => require.ensure([], () => resolve(require('@/pages/agent/noPermission.vue')), 'noPermission')
//提现详情
const withdrawDetail = resolve => require.ensure([], () => resolve(require('@/pages/agent/withdrawDetail.vue')), 'withdrawDetail')
//提现成功
const agentSuccess = resolve => require.ensure([], () => resolve(require('@/pages/agent/success.vue')), 'agentSuccess')
//提现
const withdraw = resolve => require.ensure([], () => resolve(require('@/pages/agent/withdraw.vue')), 'withdraw')
//代理邀请 1 /agent/agentSign
const agentSign = resolve => require.ensure([], () => resolve(require('@/pages/agent/agentSign.vue')), 'agentSign')
//充值
const agentRecharge = resolve => require.ensure([], () => resolve(require('@/pages/agent/recharge.vue')), 'agentRecharge')
//充值自定义
const agentCustomRecharge = resolve => require.ensure([], () => resolve(require('@/pages/agent/customRecharge.vue')), 'agentCustomRecharge')
// 会员绑定界面
const numberBand = resolve => require.ensure([], () => resolve(require('@/pages/menu/index.vue')), 'numberBand')
// 订单管理 代理平台订单
const proxyOrderManager = resolve => require.ensure([], () => resolve(require('@/pages/menu/orderManager.vue')), 'proxyOrderManager')
// 预约功能 
const indexChooseShop = resolve => require.ensure([], () => resolve(require('@/pages/subscribe/indexChooseShop.vue')), 'indexChooseShop')
const chooseItem = resolve => require.ensure([], () => resolve(require('@/pages/subscribe/chooseItem.vue')), 'chooseItem')
const itemDiy = resolve => require.ensure([], () => resolve(require('@/pages/subscribe/itemDiy.vue')), 'itemDiy')
const payOnline = resolve => require.ensure([], () => resolve(require('@/pages/subscribe/payOnline.vue')), 'payOnline')
const AppointmentList = resolve => require.ensure([], () => resolve(require('@/pages/appointment/appointment-list/AppointmentList.vue')), 'AppointmentList')

// 签名 PC 划卡支付成功后发送到移动客户端进行签名
const MobileSignature = resolve => require.ensure([], () => resolve(require('@/pages/mobileSignature/index.vue')), 'MobileSignature')
// 选择千人千面模板
const selectTemplate = resolve => require.ensure([], () => resolve(require('@/components/chat/selectTemplate')), 'selectTemplate')

// 千人千面选择封面
const ChooseFaceImg = resolve => require.ensure([], () => resolve(require('@/pages/faceEach/chooseFaceImg.vue')), 'ChooseFaceImg')
// 红包首页
const RedPacket = resolve => require.ensure([], () => resolve(require('@/pages/redPacket/index.vue')), 'RedPacket')

// 我的客户 目标客户相关
const myAgent = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/index.vue')), 'myAgent')
const agentIndexPage = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/agentIndexPage.vue')), 'agentIndexPage')
const trackHistory = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/trackHistory.vue')), 'trackHistory')
const editTrackClientMark = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/editTrackClientMark.vue')), 'editTrackClientMark')
const addClients = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/addClients.vue')), 'addClients')
const addEditTarget = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/addEditTarget.vue')), 'addEditTarget')
const addEditRemarks = resolve => require.ensure([], () => resolve(require('@/pages/a_myAgent/addEditRemarks.vue')), 'addEditRemarks')


Vue.use(Router)

let router = new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '个人中心'
    }
  },
  // 预约
  /**我的预约首页  更换组件 */
  {
    path: '/indexChooseShop',
    name: 'indexChooseShop',
    component: AppointmentList,
    meta: {
      title: '我要预约'
    }
  },
  {
    path: '/chooseItem',
    name: 'chooseItem',
    component: chooseItem,
    meta: {
      title: '预约'
    }
  },
  {
    path: '/itemDiy',
    name: 'itemDiy',
    component: itemDiy,
    meta: {
      title: '选择项目'
    }
  },
  {
    path: '/mobileSignature/index',
    name: 'mobileSignature',
    component: MobileSignature,
    meta: {
      title: '签名'
    }
  },
  {
    path: '/payOnline',
    name: 'payOnline',
    component: payOnline,
    meta: {
      title: '结算'
    }
  },
  //聊天
  {
    path: '/chat',
    name: 'chat',
    component: chat,
    meta: {
      title: '沟通'
    }
  },
  //聊天
  {
    path: '/marketingProgram',
    name: 'marketingProgram',
    component: _marketingProgram,
    meta: {
      title: '营销活动'
    }
  },
  //聊天
  {
    path: '/remindingRevisit',
    name: 'remindingRevisit',
    component: remindingRevisit,
    meta: {
      title: '回访'
    }
  },
  //聊天
  {
    path: '/selectTemplate',
    name: 'selectTemplate',
    component: selectTemplate,
    meta: {
      title: '千人千面营销模板'
    }
  },
  




  {
    path: '/birthDay',
    name: 'birth',
    component: birth,
    meta: {
      title: '生日祝福'
    }
  },
  {
    path: '/gift',
    name: 'gift',
    component: gift,
    meta: {
      title: '生日礼物'
    }
  },


  {
    path: '/toker',
    name: 'toker',
    component: toker,
    meta: {
      title: '今日关注'
    }
  },
  {
    path: '/tokerGift',
    name: 'tokerGift',
    component: tokerGift,
    meta: {
      title: '拓客礼物'
    }
  },

  {
    path: '/futureCustomers',
    name: 'futureCustomers',
    component: futureCustomers,
    meta: {
      title: '潜在客户'
    }
  },
    {
    path: '/futureCustomersDetail/:id',
    name: 'futureCustomersDetail',
    component: futureCustomersDetail,
    meta: {
      title: '详情'
    }
  },

  


  {
    path: '/menu',
    name: 'menu',
    component: menu,
    meta: {
      title: '更多'
    }
  },
  // {
  //   path: '/reminding',
  //   name: 'reminding',
  //   component: reminding,
  //   meta: {
  //     title: '回访'
  //   }
  // },
  {
    path: '/readySend',
    name: 'readySend',
    component: readySend,
    meta: {
      title: '回访'
    }
  },
  {
    path: '/singleChat/:id',
    name: 'singleChat',
    component: singleChat,
    meta: {
      title: ''
    }
  },
  {
    path: '/cash',
    name: 'cash',
    component: cash,
    meta: {
      title: '提现'
    }
  },
  {
    path: '/bonus',
    name: 'bonus',
    component: bonus,
    meta: {
      title: '现金红包'
    }
  },
  {
    path: '/outList',
    name: 'outList',
    component: outList,
    meta: {
      title: ''
    }
  },
  {
    path: '/withdrawPay',//提现支付确认页面
    name: 'inList',
    component: inList,
    meta: {
      title: ''
    }
  },
  {
    path: '/present',
    name: 'present',
    component: present,
    meta: {
      title: '送朋友'
    }
  },
  {
    path: '/preRecord',
    name: 'preRecord',
    component: preRecord,
    meta: {
      title: '送朋友记录'
    }
  },
  {
    path: '/receive/:id',
    name: 'receive',
    component: receivePresent,
    meta: {
      title: ''
    }
  },
  {
    path: '/itemShare/:id',
    name: 'itemShare',
    component: itemShare,
    meta: {
      title: ''
    }
  },
  {
    path: '/sendDetail',
    name: 'sendDetail',
    component: sendDetail,
    meta: {
      title: ''
    }
  },
  {
    path: '/appointment',
    name: 'appointment',
    component: appointment,
    meta: {
      title: '预约'
    }
  },
  {
    path: '/balance',
    name: 'balance',
    component: balance,
    meta: {
      title: '账户余额'
    }
  },
  {
    path: '/appointList',
    name: 'appointList',
    component: appointList,
    meta: {
      title: '预约记录'
    }
  },
  {
    path: '/timer',
    name: 'timer',
    component: timer,
    meta: {
      title: ''
    }
  },
  {
    path: '/staff',
    name: 'staff',
    component: staff,
    meta: {
      title: '选择员工'
    }
  },
  {
    path: '/stores',
    name: 'stores',
    component: stores,
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/staffStores',
    name: 'staffStores',
    component: staffStores,
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/success',
    name: 'success',
    component: success,
    meta: {
      title: ''
    }
  },
  {
    path: '/successOrder',
    name: 'successOrder',
    component: successOrder,
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/item',
    name: 'item',
    component: item,
    meta: {
      title: '预约项目'
    }
  },
  {
    path: '/selectPackage',
    name: 'selectPackage',
    component: selectPackage,
    meta: {
      title: '选择套餐'
    }
  },
  {
    path: '/storeManager',
    name: 'storeManager',
    component: storeManager,
    meta: {
      title: '员工中心'
    }
  },
  {
    path: '/shoppingSheet',
    name: 'shoppingSheet',
    component: shoppingSheet,
    meta: {
      title: '消费记录'
    }
  },
  {
    path: '/decrement',
    name: 'decrement',
    component: decrement,
    meta: {
      title: ''
    }
  },
  {
    path: '/sales',
    name: 'sales',
    component: sales,
    meta: {
      title: ''
    }
  },
  {
    path: '/charge',
    name: 'charge',
    component: charge,
    meta: {
      title: ''
    }
  },
  {
    path: '/earnest',
    name: 'earnest',
    component: earnest,
    meta: {
      title: ''
    }
  },
  {
    path: '/change',
    name: 'change',
    component: change,
    meta: {
      title: ''
    }
  },
  {
    path: '/returns',
    name: 'returns',
    component: returns,
    meta: {
      title: ''
    }
  },
  {
    path: '/store',
    name: 'store',
    component: store,
    meta: {
      title: '商城'
    }
  },
  {
    path: '/storeDetail/:id',
    name: 'storeDetail',
    component: storeDetail,
    meta: {
      title: ''
    }
  },
  {
    path: '/bill/:id',
    name: 'bill',
    component: bill,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/payFinish',
    name: 'payFinish',
    component: payFinish,
    meta: {
      title: '支付完成'
    }
  },
  {
    path: '/appointMe',
    name: 'appointMe',
    component: appointMe,
    meta: {
      title: '预约我的'
    }
  },
  {
    path: '/appointAll',
    name: 'appointAll',
    component: appointAll,
    meta: {
      title: '预约总览'
    }
  },
  {
    path: '/quickAppoint',
    name: 'quickAppoint',
    component: quickAppoint,
    meta: {
      title: '快速预约'
    }
  },
  {
    path: '/myShift',
    name: 'myShift',
    component: myShift,
    meta: {
      title: '我的排班'
    }
  },
  {
    path: '/setTimeOut',
    name: 'setTimeOut',
    component: setTimeOut,
    meta: {
      title: '我的服务时间'
    }
  }, {
    path: '/appointSource',
    name: 'appointSource',
    component: appointSource,
    meta: {
      title: '预约资源'
    }
  }, {
    path: '/treeStore',
    name: 'treeStore',
    component: treeStore,
    meta: {
      title: ''
    }
  },
  {
    path: '/source',
    name: 'source',
    component: source,
    meta: {
      title: ''
    }
  },
  {
    path: '/accountList',
    name: 'accountList',
    component: accountList,
    meta: {
      title: ''
    }
  },
  {
    path: '/groupIndex',
    name: 'groupIndex',
    component: groupIndex,
    meta: {
      title: '拼团商城'
    }
  },
  {
    path: '/groupDetails/:id',
    name: 'groupDetails',
    component: groupDetails,
    meta: {
      title: '拼团详情'
    }
  },
  // {
  //     path: '/groupBuy',
  //     name: 'groupBuy',
  //     component: groupBuy,
  //     meta: {
  //         title: '拼团购买'
  //     }
  // },
  {
    path: '/groupStatus',
    name: 'groupStatus',
    component: groupStatus,
    meta: {
      title: '拼团状态'
    }
  },
  {
    path: '/seckill/detail/:id',
    name: 'seckillDetail',
    component: seckillDetail,
    meta: {
      title: '抢购详情'
    }
  },
  {
    path: '/seckill',
    name: 'seckillIndex',
    component: seckillIndex,
    meta: {
      title: '抢购商城'
    }
  },
  {
    path: '/seckillEvaluate/:id',
    name: 'seckillEvaluate',
    component: seckillEvaluate,
    meta: {
      title: '评价'
    }
  },
  {
    path: '/seckillRecord/:id',
    name: 'seckillRecord',
    component: seckillRecord,
    meta: {
      title: '购买记录'
    }
  },
  {
    path: '/editEvalute/:id',
    name: 'editEvalute',
    component: editEvalute,
    meta: {
      title: '评价商品'
    }
  },

  {
    path: '/tuoke/index',
    name: 'tuokeIndex',
    component: tuokeIndex,
    meta: {
      title: '疯狂拓客'
    }
  },
  {
    path: '/tuoke/detail/:id',
    name: 'tuokeDetail',
    component: tuokeDetail,
    meta: {
      title: ''
    }
  },
  {
    path: '/tuoke/record/:id',
    name: 'tuokeRecord',
    component: tuokeRecord,
    meta: {
      title: ''
    }
  },
  {
    path: '/tuoke/evalute/:id',
    name: 'tuokeEvalute',
    component: tuokeEvalute,
    meta: {
      title: ''
    }
  },
  {
    path: '/tuoke/evalute/:id/edit',
    name: 'tuokeEvaluteEdit',
    component: tuokeEvaluteEdit,
    meta: {
      title: ''
    }
  },

  {
    path: '/groupDetail',
    name: 'groupDetail',
    component: groupDetail,
    meta: {
      title: '拼团详情'
    }
  },
  {
    path: '/selectType',
    name: 'selectType',
    component: selectType,
    meta: {
      title: ''
    }
  },
  {
    path: '/share',
    name: 'share',
    component: share,
    meta: {
      title: '分享'
    }
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: paySuccess,
    meta: {
      title: ''
    }
  },
  {
    path: '/groupShare',
    name: 'groupShare',
    component: groupShare,
    meta: {
      title: ''
    }
  },
  {
    path: '/activeEnd',
    name: 'activeEnd',
    component: activeEnd,
    meta: {
      title: ''
    }
  },
  {
    path: '/memberType',
    name: 'memberType',
    component: memberType,
    meta: {
      title: ''
    }
  },
  {
    path: '/reRecord',
    name: 'reRecord',
    component: reRecord,
    meta: {
      title: ''
    }
  },
  {
    path: '/remindContent',
    name: 'remindContent',
    component: remindContent,
    meta: {
      title: ''
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component: invite,
    meta: {
      title: '邀请员工'
    }
  },
  {
    path: '/invitor',
    name: 'invitor',
    component: invitor,
    meta: {
      title: ''
    }
  },
  {
    path: '/swipeCode',
    name: 'swipeCode',
    component: swipeCode,
    meta: {
      title: '扫码登录'
    }
  },
  {
    path: '/swipeStore',
    name: 'swipeStore',
    component: swipeStore,
    meta: {
      title: ''
    }
  },
  {
    path: '/swipeSuccess',
    name: 'swipeSuccess',
    component: swipeSuccess,
    meta: {
      title: '扫码成功'
    }
  },
  {
    path: '/selectSpeech',
    name: 'selectSpeech',
    component: selectSpeech,
    meta: {
      title: '选择话术'
    }
  },
  {
    path: '/address',
    name: 'address',
    component: address,
    meta: {
      title: '选择地址'
    }
  },
  {
    path: '/address/add',
    name: 'addAddress',
    component: addAddress,
    meta: {
      title: '地址管理'
    }
  },
  {
    path: '/lottery/:id',
    name: 'plaidLottery',
    component: plaidLottery,
    meta: {
      title: '抽奖'
    }
  },

  //   {
  //     path: '/WinningSubmiSuccess',
  //     name: 'WinningSubmiSuccess',
  //     component: WinningSubmissionSuccess,
  //     meta: {
  //       title: '地址提交完成'
  //     }
  //   },




  {
    path: '/waterList',
    name: 'waterList',
    component: waterList,
    meta: {
      title: '账户流水'
    }
  },
  {
    path: '/comment',
    name: 'comment',
    component: comment,
    meta: {
      title: '评论'
    }
  },
  {
    path: '/commentList/:id/:type',
    name: 'commentList',
    component: commentList,
    meta: {
      title: '评论列表'
    }
  },



  {
    path: '/plugin/:pluginId',
    name: 'plugin',
    component: tweet,
    meta: {
      title: ''
    }
  },

  {
    path: '/plugin/:pluginId',
    name: 'plugin',
    component: tweet,
    meta: {
      title: ''
    }
  },
  {
    path: '/getGift/:giftDefineId',
    name: 'getGift',
    component: getGift,
    meta: {
      title: '礼物'
    }
  },

  {
    path: '/activityRegistration/:id',
    name: 'activityRegistration',
    component: activityRegistration,
    meta: {
      title: '营销活动报名'
    }
  },
  {
    path: '/activityRegistration/:id/confirm',
    name: 'confirmRegistration',
    component: confirmRegistration,
    meta: {
      title: '营销活动确认报名'
    }
  },
  {
    path: '/activityRegistration/:id/success',
    name: 'registrationSuccess',
    component: registrationSuccess,
    meta: {
      title: '报名成功'
    }
  },
  {
    path: '/activityRegistration/:id/record',
    name: 'registrationRecord',
    component: registrationRecord,
    meta: {
      title: '营销活动报名用户列表'
    }
  },





  {
    path: '/getGiftSuccess/:giftDefineId',
    name: 'receiveSuccess',
    component: receiveSuccess,
    meta: {
      title: '确认领取'
    }
  },
  {
    path: '/getGift/:giftDefineId/evalute',
    name: 'giftEvalute',
    component: giftEvalute,
    meta: {
      title: '评价列表'
    }
  },
  {
    path: '/getGift/:giftDefineId/evalute/edit',
    name: 'editGiftEvalute',
    component: editGiftEvalute,
    meta: {
      title: '评价'
    }
  },
  {
    path: '/getGift/:giftDefineId/record',
    name: 'editGiftEvalute',
    component: giftRecord,
    meta: {
      title: '领取记录'
    }
  },
  {
    path: '/mall/index',
    name: 'mallIndex',
    component: mallIndex,
    meta: {
      title: '商城'
    }
  },
  {
    path: '/mall/detail/:id',
    name: 'mallDetail',
    component: mallDetail,
    meta: {
      title: ''
    }
  },
  {
    path: '/mall/record/:id',
    name: 'mallRecord',
    component: mallRecord,
    meta: {
      title: ''
    }
  },
  {
    path: '/mall/evalute/:id',
    name: 'mallEvalute',
    component: mallEvalute,
    meta: {
      title: ''
    }
  },
  {
    path: '/mall/evalute/:id/edit',
    name: 'mallEvaluteEdit',
    component: mallEvaluteEdit,
    meta: {
      title: ''
    }
  },

  {
    path: '/mintUiTest',
    name: 'mintUiTest',
    component: mintUiTest,
    meta: {
      title: 'mint-ui-test'
    }
  },
  {
    path: '/personal',
    name: 'personal',
    component: personal,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/subordinate',
    name: 'subordinate',
    component: subordinate,
    meta: {
      title: '查看下级'
    }
  },
  {
    path: '/marketingprograms',
    name: 'marketingprogram',
    component: marketingprogram,
    meta: {
      title: '营销方案'
    }
  },
  {
    path: '/marketing/shop/:id',
    name: 'marketingShop',
    component: marketingShop,
    meta: {
      title: '营销方案'
    }
  },
  {
    path: '/marketingmember/:id',
    name: 'marketingmember',
    component: marketingmember,
    meta: {
      title: '营销方案'
    }
  },
  {
    path: '/marketingShoppingDetail/:id',
    name: 'marketingShoppingDetail',
    component: marketingShoppingDetail,
    meta: {
      title: '购买明细数据'
    }
  },
  {
    path: '/memberdetail',
    name: 'memberdetail',
    component: memberdetail,
    meta: {
      title: '营销方案'
    }
  },
  {
    path: '/marketing/memberShare/:id',
    name: 'marketingMemberShare',
    component: marketingMemberShare,
    meta: {
      title: '营销方案'
    }
  },
  {
    path: '/marketing/shoppingDetail/:id',
    name: 'marketingShoppingDetail',
    component: marketingShoppingDetail,
    meta: {
      title: '购买明细数据'
    }
  },
  {
    path: '/marketingdetail/:id',
    name: 'marketingdetail',
    component: marketingdetail,
    meta: {
      title: '营销方案详情'
    }
  },
  {
    path: '/commission',
    name: 'commission',
    component: commission,
    meta: {
      title: '我的业绩提成'
    }
  },
  {
    path: '/percommission',
    name: 'percommission',
    component: percommission,
    meta: {
      title: '员工业绩提成'
    }
  },
  {
    path: '/MarketingShare',
    name: 'MarketingShare',
    component: MarketingShare,
    meta: {
      title: '营销分享'
    }
  },
  {
    path: '/marketingRedPacket',
    name: 'marketingRedPacket',
    component: marketingRedPacket,
    meta: {
      title: '红包明细'
    }
  },
  {
    path: '/redPacketRecharge',
    name: 'redPacketRecharge',
    component: redPacketRecharge,
    meta: {
      title: '红包充值'
    }
  },
  {
    path: '/rechargeSuccess',
    name: 'rechargeSuccess',
    component: rechargeSuccess,
    meta: {
      title: '充值成功'
    }
  },
  {
    path: '/addThousandFaces',
    name: 'AddThousandFaces',
    component: AddThousandFaces,
    meta: {
      title: '千人千面营销'
    }
  },
  {
    path: '/addChatThousandFaces',
    name: 'AddChatThousandFaces',
    component: AddChatThousandFaces,
    meta: {
      title: '千人千面营销'
    }
  },
  {
    path: '/previewItem',
    name: 'PreviewItem',
    component: PreviewItem,
    meta: {
      title: '千人千面预览'
    }
  },
  {
    path: '/previewChatItem',
    name: 'PreviewChatItem',
    component: PreviewChatItem,
    meta: {
      title: '千人千面预览'
    }
  },
  {
    path: '/memberBuy',
    name: 'MemberBuy',
    component: MemberBuy,
    meta: {
      title: '购买'
    }
  },
  {
    path: '/MarketingShares',
    name: 'MarketingShares',
    component: MarketingShares,
    meta: {
      title: '营销分享'
    }
  },
  {
    path: '/operStatement',
    name: 'operStatement',
    component: operStatement,
    meta: {
      title: '营业报表',
      keepAlive: true
    }
  },
  {
    path: '/operStatement/detall',
    name: 'operStatementDetall',
    component: operStatementDetall,
    meta: {
      title: '营业报表',
    }
  },
  {
    path: '/serviceComment',
    name: 'serviceComment',
    component: serviceComment,
    meta: {
      title: '服务评价',
      keepAlive: true
    }
  },
  {
    path: '/serviceComment/detail',
    name: 'serviceCommentDetail',
    component: serviceCommentDetail,
    meta: {
      title: '服务评价详情',
    }
  },
  {
    path: '/attentionCash',
    name: 'attentionCash',
    component: attentionCash,
    meta: {
      title: '提现',
    }
  },
  {
    path: '/organizationBill',
    name: 'organizationBill',
    component: organizationBill,
    meta: {
      title: '对账',
    }
  },
  {
    path: '/inShop',
    name: 'inShop',
    component: inShop,
    meta: {
      title: '今日到店',
      keepAlive: true
    }
  },
  {
    path: '/inShop/modifyStoreMember',
    component: modifyStoreMember,
    meta: {
      title: '修改资料'
    }
  },
  {
    path: '/inShop/customerPhotos',
    component: customerPhotos,
    meta: {
      title: '到店会员'
    }
  },
  {
    path: '/inShop/comparePhotos',
    component: comparePhotos,
    meta: {
      title: '照片对比'
    }
  },
  {
    path: '/memberMediaCompare',
    component: memberMediaCompare,
    meta: {
      title: '照片对比'
    }
  },
  {
    path: '/inShop/addPhotos',
    component: addPhotos,
    meta: {
      title: '新增照片'
    }
  },
  {
    path: '/addStatistics',
    name: 'addStatistics',
    component: addStatistics,
    meta: {
      title: '新增统计',
    }
  },
  {
    path: '/buyDetail',
    name: 'buyDetail',
    component: buyDetail,
    meta: {
      title: '购买明细',
    }
  },
  {
    path: '/addGuest',
    name: 'addGuest',
    component: addGuest,
    meta: {
      title: '拓客',
    }
  },
  {
    path: '/votedone',
    name: 'votedone',
    component: votedone,
    meta: {
      title: '投票完成',
    }
  },
  {
    path: '/importMobile',
    name: 'importMobile',
    component: importMobile,
    meta: {
      title: '黑白名单',
    }
  },
  {
    path: '/pullToTest',
    name: 'pullToTest',
    component: pullToTest,
    meta: {
      title: '测试',
    }
  },
  {
    path: '/addMobile',
    name: 'addMobile',
    component: addMobile,
    meta: {
      title: '黑白名单修改',
      // keepAlive: true
    }
  },
  {
    path: '/vote',
    name: 'vote',
    component: vote,
    meta: {
      title: '投票'
    },
    children: [

      {
        path: 'rank',
        name: 'rank',
        component: rank,
        meta: {
          title: '排行榜'
        }
      },
      {
        path: 'description',
        name: 'description',
        component: description,
        meta: {
          title: '活动说明'
        }
      },
      {
        path: '',
        name: 'home',
        component: home,
        meta: {
          title: '投票'
        }
      },
      {
        path: 'lookOverHome',
        name: 'lookOverHome',
        component: lookOverHome,
        meta: {
          title: '投票'
        }
      },

    ]
  },

  {
    path: '/vote/voteNumberPerson',
    name: 'voteNumberPerson',
    component: voteNumberPerson,
    meta: {
      title: '投票人数'
    }
  },
  {
    path: '/vote/voteDescription',
    name: 'voteDescription',
    component: voteDescription,
    meta: {
      title: '投票报名'
    }
  },



  {
    path: '/vote/voteQRCode',
    name: 'voteQRCode',
    component: voteQRCode,
    meta: {
      title: '投票二维码'
    }
  },
  {
    path: '/vote/voteDetails',
    name: 'voteDetails',
    component: voteDetails,
    meta: {
      title: '投票详情'
    }
  },





  {
    path: '/vote/index',
    name: 'voteIndex',
    component: voteIndex,
    meta: {
      title: '投票列表'
    }
  },
  {
    path: '/vote/updateImage',
    name: 'voteUpdateImage',
    component: voteUpdateImage,
    meta: {
      title: '更新形象'
    }
  },
  {
    path: '/agent/index',
    name: 'agentIndex',
    component: agentIndex,
    meta: {
      title: '代理中心',
    }
  },
  {
    path: '/myAgent',
    name: 'myAgent',
    component: myAgent,
    meta: {
      title: '我的客户',
    }
  },
  {
    path: '/agentIndexPage',
    name: 'agentIndexPage',
    component: agentIndexPage,
    meta: {
      title: '目标客户',
      keepAlive: true
    }
  },
  {
    path: '/trackHistory',
    name: 'trackHistory',
    component: trackHistory,
    meta: {
      title: '跟进历史',
    }
  },
  {
    path: '/editTrackClientMark',
    name: 'editTrackClientMark',
    component: editTrackClientMark,
    meta: {
      title: '修改客户标签',
    }
  },
  {
    path: '/addClients',
    name: 'addClients',
    component: addClients,
    meta: {
      title: '添加客户',
    }
  },
  {
    path: '/addEditTarget',
    name: 'addEditTarget',
    component: addEditTarget,
    meta: {
      title: '编辑目标',
    }
  },
  {
    path: '/addEditRemarks',
    name: 'addEditRemarks',
    component: addEditRemarks,
    meta: {
      title: '编辑备注',
    }
  },
  {
    path: '/agent/noPermission',
    name: 'noPermission',
    component: noPermission,
    meta: {
      title: '代理中心',
    }
  },
  {
    path: '/agent/withdrawDetailRebate',
    component: withdrawDetail,
    meta: {
      title: '提现明细',
    }
  },
  {
    path: '/agent/withdrawDetailBalance',
    component: withdrawDetail,
    meta: {
      title: '余额明细',
    }
  },
  {
    path: '/agent/agentSign',
    name: 'agentSign',
    component: agentSign,
    meta: {
      title: '申请代理',
    }
  },
  {
    path: '/agent/recharge',
    name: 'agentRecharge',
    component: agentRecharge,
    meta: {
      title: '充值',
    }
  },
  {
    path: '/agent/customRecharge',
    name: 'agentCustomRecharge',
    component: agentCustomRecharge,
    meta: {
      title: '充值自定义',
    }
  },
  {
    path: '/agent/success',
    name: 'agentSuccess',
    component: agentSuccess,
    meta: {
      title: '充值成功',
    }
  },
  {
    path: '/agent/withdraw',
    name: 'withdraw',
    component: withdraw,
    meta: {
      title: '提现',
    }
  },
  {
    path: '/order/orderDetail',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      title: '收银'
    }
  },
  {
    path: '/order/index',
    name: 'orderIndex',
    component: orderIndex,
    meta: {
      title: '收银',
      keepAlive: true
    }
  },
  {
    path: '/order/editPrice/:id',
    name: 'editOrdePrice',
    component: editOrdePrice,
    meta: {
      title: '调整价格',
    }
  },
  {
    path: '/order/editPayType/:id',
    name: 'editPayType',
    component: editPayType,
    meta: {
      title: '支付方式'
    }
  },
  {
    path: '/order/editStaff/:id',
    name: 'editOrderStaff',
    component: editOrderStaff,
    meta: {
      title: '选择员工'
    }
  },
  {
    path: '/order/editItem/:id',
    name: 'editOrderItem',
    component: editOrderItem,
    meta: {
      title: '调整套餐'
    }
  },
  {
    path: '/order/repayment/:id',
    name: 'repaymentItem',
    component: repaymentItem,
    meta: {
      title: '还款'
    }
  },
  {
    path: '/order/billing',
    name: 'orderBilling',
    component: orderBilling,
    meta: {
      title: '会员余额'
    }
  },
  {
    path: '/createShop',
    name: 'createShop',
    component: createShop,
    meta: {
      title: '门店',
      // keepAlive: true
    }
  },
  {
    path: '/editShop',
    name: 'editShop',
    component: editShop,
    meta: {
      title: '门店'
    }
  },
  {
    path: '/inviteStaff',
    name: 'inviteStaff',
    component: inviteStaff,
    meta: {
      title: '邀请员工'
    }
  },
  {
    path: '/editStaff',
    name: 'editStaff',
    component: editStaff,
    meta: {
      title: '编辑员工'
    }
  },
  {
    path: '/serviceEvaluation/index',
    name: 'serviceEvaluation',
    component: serviceEvaluation,
    meta: {
      title: '服务评价'
    }
  },
  {
    path: '/serviceEvaluation/success',
    name: 'evaluationSuccess',
    component: evaluationSuccess,
    meta: {
      title: '评价成功'
    }
  },
  {
    path: '/returnVisit/index',
    name: 'returnVisitIndex',
    component: returnVisit,
    meta: {
      title: ''
    }
  },
  {
    path: '/returnVisit/add',
    name: 'addReturnVisit',
    component: addReturnVisit,
    meta: {
      title: '新增'
    }
  },
  {
    path: '/returnVisit/addOfTemplate',
    name: 'addOfTemplate',
    component: addOfTemplate,
    meta: {
      title: '按模板新增',
      keepAlive: true
    }
  },
  {
    path: '/returnVisit/visitTemplate',
    name: 'visitTemplate',
    component: visitTemplate,
    meta: {
      title: '模板'
    }
  },
  {
    path: '/personal/index',
    name: 'personalIndex',
    component: personalIndex,
    meta: {
      title: '我'
    }
  },
  {
    path: '/personal/agent',
    name: 'personalAgent',
    component: personalAgent,
    meta: {
      title: '我的代理'
    }
  },
  {
    path: '/personal/approvalAgent',
    name: 'approvalAgent',
    component: approvalAgent,
    meta: {
      title: '待审批代理'
    }
  },
  {
    path: '/personal/approvalAgentDetail',
    name: 'approvalAgentDetail',
    component: approvalAgentDetail,
    meta: {
      title: '待审批代理'
    }
  },
  {
    path: '/personal/approvalColleague',
    name: 'approvalColleague',
    component: approvalColleague,
    meta: {
      title: '待审批同事'
    }
  },
  {
    path: '/personal/colleague',
    name: 'colleague',
    component: colleague,
    meta: {
      title: '我的同事'
    }
  },
  {
    path: '/personal/companyDetail',
    name: 'companyDetail',
    component: companyDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/personal/agentDetail',
    name: 'pAgentDetail',
    component: pAgentDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/personal/colleagueDetail',
    name: 'colleagueDetail',
    component: colleagueDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/personal/editAgent',
    name: 'editAgent',
    component: editAgent,
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/personal/charge',
    name: 'personalCharge',
    component: personalCharge,
    meta: {
      title: '充值'
    }
  },
  {
    path: '/personal/invite',
    name: 'personalInvite',
    component: personalInvite,
    meta: {
      title: '邀请同事'
    }
  },
  {
    path: '/personal/qrcodeAgent',
    component: personalQrcode,
    meta: {
      title: '邀请代理'
    }
  },
  {
    path: '/personal/qrcodeColleague',
    component: personalQrcode,
    meta: {
      title: '邀请同事'
    }
  },
  {
    path: '/personal/success',
    component: personalSuccess,
    meta: {
      title: '注册成功'
    }
  },
  {
    path: '/AgentClient',
    name: 'AgentClient',
    component: AgentClient,
    meta: {
      title: '我的客户'
    }
  },
  {
    path: '/AgentClientIndex',
    component: AgentClientIndex,
    meta: {
      title: '我的客户'
    }
  },
  {
    path: '/AgentClient/clientIndex',
    component: ClientIndex,
    meta: {
      title: ''
    }
  },
  {
    path: '/AgentClient/clientAuth',
    component: ClientWxAuth,
    meta: {
      title: '微信授权'
    }
  },
  {
    path: '/AgentClient/templateList',
    component: TemplateList,
    meta: {
      title: '模板消息列表'
    }
  },
  {
    path: '/AgentClient/chooseOrder',
    component: ClientChooseOrder,
    meta: {
      title: '创建订单'
    }
  },
  {
    path: '/AgentClient/detail',
    name: 'AgentDetail',
    component: AgentDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/AgentClient/qrcode',
    name: 'AgentQrcode',
    component: AgentQrcode,
    meta: {
      title: ''
    }
  },
  {
    path: '/AgentClient/edit',
    name: 'AgentEdit',
    component: AgentEdit,
    meta: {
      title: ''
    }
  },
  {
    path: '/AgentClient/editPrice',
    component: AgentEditPrice,
    meta: {
      title: '价格信息'
    }
  },
  {
    path: '/AgentClient/addStore',
    component: AgentAddStore,
    meta: {
      title: '门店'
    }
  },
  {
    path: '/AgentClient/payCreateOrder',
    component: AgentPayCreateOrder,
    meta: {
      title: '购买详情'
    }
  },
  {
    path: '/AgentClient/paySuccess',
    component: AgentPaySuccess,
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/forwxapp/successPage',
    name: 'successPage',
    component: successPage,
    meta: {
      title: '扫码登录绑定'
    }
  },
  {
    path: '/chooseFaceImg',
    name: 'chooseFaceImg',
    component: ChooseFaceImg,
    meta: {
      title: '选择封面'
    }
  },
  {
    path: '/redPacket',
    name: 'redPacket',
    component: RedPacket,
    meta: {
      title: '美丽在线给您发红包'
    }
  },
  {
    path: '/numberBand',
    name: 'numberBand',
    component: numberBand
  },
  {
    path: '/AgentClient/proxyOrderManager',
    name: 'proxyOrderManager',
    component: proxyOrderManager
  },

  ...appointments



    //...LuckDrawPages
  ]
})

router.afterEach(route => {
  let title = route.meta && route.meta.title ? route.meta.title : '';
  setTitle(title);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js